import React, {Component} from 'react';
import { AuthContext } from "../../Auth.js"
import Styles from './index.module.css'

class RegistrarH extends Component{

	constructor(props){
        super(props);
        const today = new Date();
        const date = today.getDate()+'/'+(today.getMonth()+1)+'/'+today.getFullYear()+' '+today.getHours()+':'+today.getMinutes();
		this.state = {
            date: date,
            fecha: today,
			sector: '',
			tuneles: {
                tunel1:{tunel:'',cama:'',H1:'',H2:'',H3:''},
                tunel2:{tunel:'',cama:'',H1:'',H2:'',H3:''},
                tunel3:{tunel:'',cama:'',H1:'',H2:'',H3:''},
            },
		};
		this.handleUserInput = this.handleUserInput.bind(this);
		this.writeNew = this.writeNew.bind(this);
        this.changeModal= this.props.changeModal;
	}

	handleUserInput(event){
		this.setState({
			[event.target.name]: event.target.value
        })
    }
    handleUserInputT1=(event)=>{
		this.setState({
			tuneles:{...this.state.tuneles, tunel1:{...this.state.tuneles.tunel1, [event.target.name]:event.target.value}}
        })
    }
    handleUserInputT2=(event)=>{
		this.setState({
			tuneles:{...this.state.tuneles, tunel2:{...this.state.tuneles.tunel2, [event.target.name]:event.target.value}}
        })
    }
    handleUserInputT3=(event)=>{
		this.setState({
			tuneles:{...this.state.tuneles, tunel3:{...this.state.tuneles.tunel3, [event.target.name]:event.target.value}}
        })
    }

	writeNew(event){
		event.preventDefault()
		const data = {...this.state};
		this.props.newRegistro(data);
		this.setState({
			fecha: '',
            sector: '',
            tuneles: {
                tunel1:{tunel:'',cama:'',H1:'',H2:'',H3:''},
                tunel2:{tunel:'',cama:'',H1:'',H2:'',H3:''},
                tunel3:{tunel:'',cama:'',H1:'',H2:'',H3:''},
            },
		})
		this.changeModal(false)
	}
    static contextType = AuthContext;
	render(){
		return(
			<div>
				<form onSubmit={this.writeNew}>
                    <div className="input">Nombre: {this.context.currentUser.name}</div>

                    <div className="input">Fecha: {this.state.date}</div>

					<div className="input">Sector: <input type='int' 
					name='sector' required={true} onChange={this.handleUserInput}/></div>

					<div>Tomar lectura de 3 tuneles</div>
                    <div className={Styles.tunel}>
                        <div>Tunel: <input type='int' required={true} name='tunel' onChange={this.handleUserInputT1} /></div>
                        <div>Cama: 
                            <input type='char' placeholder="A/B/C" required={true} name='cama' onChange={this.handleUserInputT1} />
        {/*
                            <input type='radio' id="1" name='cama' value="A" onChange={this.handleUserInputT1} />
                            <label htmlFor="1">A</label>
                            <input type='radio' id="2" name='cama' value="B" onChange={this.handleUserInputT1} />
                            <label htmlFor="2">B</label>
                            <input type='radio' id="3" name='cama' value="C" onChange={this.handleUserInputT1} />
                            <label htmlFor="3">C</label>
        */}
                        </div> 
                        <div> Lecturas de humedad: <br></br>
                        <input className={Styles.registro} placeholder="inicio" type='float' name='H1' onChange={this.handleUserInputT1} />  
                        <input className={Styles.registro} placeholder="mitad" type='float' name='H2' onChange={this.handleUserInputT1} />
                        <input className={Styles.registro} placeholder="final" type='float' name='H3' onChange={this.handleUserInputT1} />  
                        </div> 
                    </div>
                    <div className={Styles.tunel}>
                        <div>Tunel: <input type='int' required={true} name='tunel' onChange={this.handleUserInputT2} /></div>
                        <div>Cama: 
                            <input type='char' placeholder="A/B/C" required={true} name='cama' onChange={this.handleUserInputT2} />
        {/*
                            <input type='radio' id="1" name='cama' value="A" onChange={this.handleUserInputT1} />
                            <label htmlFor="1">A</label>
                            <input type='radio' id="2" name='cama' value="B" onChange={this.handleUserInputT1} />
                            <label htmlFor="2">B</label>
                            <input type='radio' id="3" name='cama' value="C" onChange={this.handleUserInputT1} />
                            <label htmlFor="3">C</label>
        */}
                        </div> 
                        <div> Lecturas de humedad: <br></br>
                        <input className={Styles.registro} placeholder="inicio" type='float' name='H1' onChange={this.handleUserInputT2} />  
                        <input className={Styles.registro} placeholder="mitad" type='float' name='H2' onChange={this.handleUserInputT2} />
                        <input className={Styles.registro} placeholder="final" type='float' name='H3' onChange={this.handleUserInputT2} />  
                        </div> 
                    </div>
                    <div className={Styles.tunel}>
                        <div>Tunel: <input type='int' required={true} name='tunel' onChange={this.handleUserInputT3} /></div>
                        <div>Cama: 
                            <input type='char' placeholder="A/B/C" required={true} name='cama' onChange={this.handleUserInputT3} />
        {/*
                            <input type='radio' id="1" name='cama' value="A" onChange={this.handleUserInputT1} />
                            <label htmlFor="1">A</label>
                            <input type='radio' id="2" name='cama' value="B" onChange={this.handleUserInputT1} />
                            <label htmlFor="2">B</label>
                            <input type='radio' id="3" name='cama' value="C" onChange={this.handleUserInputT1} />
                            <label htmlFor="3">C</label>
        */}
                        </div> 
                        <div> Lecturas de humedad: <br></br>
                        <input className={Styles.registro} placeholder="inicio" type='float' name='H1' onChange={this.handleUserInputT3} />  
                        <input className={Styles.registro} placeholder="mitad" type='float' name='H2' onChange={this.handleUserInputT3} />
                        <input className={Styles.registro} placeholder="final" type='float' name='H3' onChange={this.handleUserInputT3} />  
                        </div> 
                    </div>

					<p><button type="submit">Guardar</button></p>
				</form>
			</div>
		)
	}
}

export default RegistrarH;